import React from "react";
import "./RewardsTickHomePage.scss"
import RewardsTickHeroPage from "./RewardsTickHeroPage";
import RewardsTickSubscribePage from "./RewardsTickSubscribePage";
import RewardsTickRewardPage from "./RewardsTickRewardPage";
import RewardsTickBenefitsPage from "./RewardsTickBenefitsPage";
import RewardsTickStepsPage from "./RewardsTickStepsPage";
import RewardsTickExpPage from "./RewardsTickExpPage";
const RewardsTickHomePage = () => {
    return (
        <div className="RewardsTickHomePage">
            <RewardsTickHeroPage />
            <RewardsTickExpPage />
            <RewardsTickStepsPage />
            <RewardsTickBenefitsPage />
            <RewardsTickRewardPage />
            <RewardsTickSubscribePage />
        </div>
    )
}
export default RewardsTickHomePage